import type { SxProps, Theme } from '@mui/material';

/** Matches `DirectoryForm` / `DocumentationForm` dialog body padding. */
export const formDialogBodySx: SxProps<Theme> = {
  p: '16px 24px',
};

/** Matches `DirectoryForm` / `DocumentationForm` dialog footer margin. */
export const formDialogFooterSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  m: '16px 24px',
};
